/**
 * SORM fields that are always set-typed on the backend. Used when the entity
 * schema omits `type: 'set'` (e.g. `Account.tags`).
 */
export const SORM_KNOWN_SET_FIELD_NAMES = new Set(['tags'])
